import React from 'react';
import Typography from '@mui/material/Typography';

interface BreadcrumbItemProps {
  onClick?: () => void;
  children: React.ReactNode;
}

export function BreadcrumbItem({ onClick, children }: BreadcrumbItemProps) {
  return (
    <Typography
      onClick={onClick}
      variant="body2"
      sx={{
        ':hover': onClick && {
          cursor: 'pointer',
          color: 'ButtonText',
          backgroundColor: (theme) => theme.palette.primary.light,
        },
        borderRadius: 2,
        px: 0.5,
      }}
    >
      {children}
    </Typography>
  );
}
